import {get,post} from "../index"
export const getLoginApi={
	// 客户信息
    getUserInfo() {
		return get('user/info')
	},
	// 登录
	getLoginwx(params){
		return post('user/loginwx',params)
	}
}


// WEBPACK FOOTER //
// ./src/api/http/login.js